import { motion } from "framer-motion";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { Dropdown, Icon, Image, Label, Segment } from "semantic-ui-react";
import { MatchView } from "../../../projectSpecific/sports/elements/matches/MatchesViewer";
import { getAlphaList } from "../../common/convert";
import { gEnums } from "../../enums/globalEnums";
import AlphabetMenuWithProvider from "../menus/AlphabetMenu";
import SearchInput from "../menus/SearchInput";
import JsonViewer from "./JsonViewer";
import { formatItem, formatTypes } from "global/common/dateFormatting";
import DraggableItem from "global/dragNDrops/DraggableItem";
import ItemMenuSquares, { _imsTypes } from "global/wrappers/ItemMenuSquares ";
// import ItemMenuSquares from "global/wrappers/ItemMenuSquares ";

const _labelSize = 'small'

const TreeViewer = ({
  asSquares,
  addJsonViewer,
  allowDrag,
  data,
  fnPopulate,
  forceAlpha,
  handleAdd,
  handleAdds,
  handleAddItem,
  handleEdit,
  handlePrivate,
  handleRemove,
  handleSelectedKey,
  handleSelectedKeys,
  ignoreAlpha,
  ignoreCount,
  ignoreCase,
  ignoreSort,
  itemChanges,
  onDrop,
  scNames,
  removeOnNonFirst,
  selectedProp,
  showHasEvent,
  showHasProfile,
  showKey,
  showLastRefreshTime,
  showRelations,
  showSelected,
  subName,
  subNames,
}) => {

  const [showAlpha, setShowAlpha] = useState(false)
  const [currentList, setCurrentList] = useState({});
  const [selectedKey, setSelectedKey] = useState();
  const [expandedKeys, setExpandedKeys] = useState({});
  const [alphaValue, setAlphaValue] = useState()
  const [sortProp, setSortProp] = useState()

  if (asSquares) {
    return <ItemMenuSquares
      menuItems={data}
      imsType={_imsTypes.match}
    />
  }

  const onDropLocal = (e, target) => {
    e.preventDefault()
    const { item, source } = JSON.parse(
      e.dataTransfer.getData('text/plain')
    )
    handleAddItem && handleAddItem(target, item)
  }

  const extractSelectedProp = (items, selectedProp, excludeNulls) => {
    const _items = {}
    _.forEach(items, (item) => {
      const { _itemKey } = item
      _items[_itemKey] = item
    })
    if (excludeNulls) {
      return _.mapValues(
        _.pickBy(_items, (item) => !!item[selectedProp]),
        (item) => ({ [selectedProp]: item[selectedProp] })
      );
    } else {
      return _.mapValues(_items, item => ({
        [selectedProp]: item[selectedProp]
      }));
    }
  };

  useEffect(() => {
    const _showAlpha = data && _.size(data) > 80 ? true : false
    setShowAlpha(!ignoreAlpha && (_showAlpha || forceAlpha))
    if (selectedProp) {
      const _filteredData = extractSelectedProp(data, selectedProp, true)
      setCurrentList(_filteredData)
    } else {
      setCurrentList(data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [data, selectedProp]);

  useEffect(() => {
    if (selectedKey) {
      handleSelectedKey && handleSelectedKey(selectedKey)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedKey]);

  useEffect(() => {
    handleSelectedKeys && handleSelectedKeys(expandedKeys)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [expandedKeys]);

  const handleAlphaChange = (av) => {
    const _alphaChar = String.fromCharCode(av)
    if (data && av) {
      let _data = data
      const { alphaList, sortProp: sp } = getAlphaList(_data, _alphaChar)
      setSortProp(sp)
      setAlphaValue(av)
      setCurrentList(alphaList)
    }
  }

  const handle_add = (e, key, fullKey) => {
    e.stopPropagation()
    handleAdd(key, fullKey)
  }

  const handle_remove = (e, key, fullKey) => {
    e.stopPropagation()
    handleRemove(key, fullKey)
  }

  const handle_edit = (e, key, fullKey) => {
    e.stopPropagation()
    handleEdit(key, fullKey)
  }

  const handle_private = (e, key, fullKey) => {
    e.stopPropagation()
    handlePrivate(key, fullKey)
  }

  const handle_profile = (e, key, fullKey) => {
    console.log('key')
  }

  const handle_event = (e, key, fullKey) => {
    console.log('key')
  }

  const handleResults = (r) => {
    const { searchType, results } = r
    console.log('results', results)
  }

  const toggleKey = (key, fullKey) => {
    setSelectedKey(fullKey === selectedKey ? null : fullKey)
    setExpandedKeys((prev) => ({
      ...prev,
      [fullKey]: !prev[fullKey],
    }));
  };


  const collapseChildrenRecursively = (parentKey, obj, eks) => {
    const newExpandedKeys = { ...eks };
    Object.keys(obj).forEach((key) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      newExpandedKeys[fullKey] = false;
      // If the child is an object or an array, recursively collapse it
      if (_.isObject(obj[key])) {
        collapseChildrenRecursively(fullKey, obj[key], newExpandedKeys);
      }
    });
    setExpandedKeys(newExpandedKeys);
    return newExpandedKeys;
  };

  const search_global = (searchType) => <SearchInput searchType={searchType} data={aps_global} handleResults={handleResults} />

  const dd = (key, fullKey, isFirst, _isPrivate) => {
    const allowAdd = (handleAdd && handleAdds && _.includes(handleAdds, key))
    const allowEdit = handleEdit && isFirst
    const allowPrivate = handlePrivate
    let allowRemove; // = handleRemove && isFirst

    if (handleRemove) {
      if (removeOnNonFirst && !isFirst) {
        allowRemove = true
      } else if (!removeOnNonFirst && isFirst) {
        allowRemove = true
      }
    }

    if (!allowAdd && !allowEdit && !allowPrivate && !allowRemove) { return; }

    return <div >
      <Dropdown
        icon='ellipsis vertical circular blue inverted'
        floating
        labeled
        direction='left'
        className='icon'>
        <Dropdown.Menu>
          {allowAdd && <Dropdown.Item icon='add' text='Add' onClick={(e) => handle_add(e, key, fullKey)} />}
          {allowEdit && <Dropdown.Item icon='edit' text='Edit' onClick={(e) => handle_edit(e, key, fullKey)} />}
          {allowPrivate && <Dropdown.Item icon='user secret' text='Private' color={_isPrivate ? 'red' : 'grey'} onClick={(e) => handle_private(e, key, fullKey)} />}
          {allowRemove && <Dropdown.Item icon='delete' text='Delete' onClick={(e) => handle_remove(e, key, fullKey)} />}
        </Dropdown.Menu>
      </Dropdown>
    </div >

  }


  const getIconGroup = (matchStatusTypes) => {
    const _icons = []
    if (matchStatusTypes) {
      _.forEach(matchStatusTypes, (mst) => {
        switch (mst) {
          case 'exactMatch':
            _icons.push(<Icon color='green' name='check circle' />)
            break;
          case 'scoresChanged':
            _icons.push(<Icon name='refresh' />)
            break;
          case 'dateChanged':
            _icons.push(<Icon name='calendar alternate outline' />)
            break;
          case 'hasResults':
            _icons.push(<Icon color='blue' name='flag' />)
            break;
        }
      })
    }
    return _icons
  }

  const getIconGroup_related = () => {
    const _icons = []
    _icons.push(<Icon color='grey' name='attach' />)
    return _icons
  }

  const getKeyCaption = (key, item, relatedCount) => {

    const { firstName, lastName, name, home, away, results, _matchStatusTypes, startDate, _itemKey, _daysAgo } = item ?? {}

    const _subName = subName ? item[subName] : null

    let caption;
    let cni;
    let iconGroup;
    let caption_sub;
    let iconCount;
    let tss;

    if (_matchStatusTypes) {
      iconGroup = getIconGroup(_matchStatusTypes)
    }

    const _key = key // key.replace('_list', '')

    if (item?.viewItems?.[_key]?.dataSource?.dataCollectionName) {
      if (item.viewItems[_key].dataSource.dataCollectionName !== _key) {
        caption_sub = <span style={{ color: 'green' }}>{' (data source: ' + _.startCase(item.viewItems[_key].dataSource.dataCollectionName) + ')'}</span>
      }
    }

    if (item?.dataSource?.dataCollectionName) {
      if (item.dataSource.dataCollectionName !== _key) {
        caption_sub = <span style={{ color: 'green' }}>{' (data source: ' + _.startCase(item.dataSource.dataCollectionName) + ')'}</span>
      }
    }

    if (startDate && !_.isObject(caption_sub)) {
      caption_sub = startDate
    }

    if (showKey) {
      caption_sub = _itemKey
    }

    if (_subName) {
      caption = _subName
    } else {
      if (subNames && _.isObject(item) && lastName && firstName && !_.isObject(lastName) && !_.isObject(firstName)) {
        caption = lastName + ', ' + firstName
      } else if (home && away) {
        if (results?.score) {
          caption = away.name + ' ' + results?.score.away + ' @ ' + home.name + ' ' + results?.score.home
          cni = '_rez'
        } else {
          caption = away.name + ' @ ' + home.name
        }
      } else if (subNames && _.isObject(item) && name && !_.isObject(name)) {
        caption = name
      } else if (/\d/.test(key)) {
        caption = key;
      } else {
        caption = scNames ? _.startCase(key) : key
      }
    }

    if (relatedCount > 0) {
      iconCount = getIconGroup_related()
    }

    if (_daysAgo) {
      tss = <div className='ts-lbls'>
        <Label size='mini' color={'black'}> {_daysAgo.createdAt}</Label>
        <Label size='mini' color={'blue'}> {_daysAgo.lastLoginAt}</Label>
        <Label size='mini' color={'green'}> {_daysAgo.lastAccessedAt}</Label>
      </div>
    }

    return { caption, cni, iconGroup, caption_sub, iconCount, tss }
  }

  const sortComplexObject = (obj) => {
    return _(obj)
      .toPairs() // Convert to an array of [key, value]
      .sortBy(([key, value]) => {
        // Check for name, firstName, or lastName; if not present, use the key
        return value && (value.firstName || value.lastName || value.name) || key;
      })
      .fromPairs() // Convert back to an object
      .value();
  };

  const getArrayCount = (obj) => {
    return _.reduce(obj, (count, value) => {
      return _.isNumber(value) || _.isArray(value) ? count + 1 : count;
    }, 0);
  };

  const urlImage = (item) => {
    const { appUserImage } = item
    const appUserUrl = appUserImage?.urls?.thumbnail
    const src = item?._file?.src
    if (src) {
      return <Image src={src} avatar style={{ marginRight: '1em', borderRadius: 0 }} />
    } else if (appUserUrl) {
      return <Image src={appUserUrl} avatar style={{ marginRight: '1em' }} />
    } else {
      return <Icon name='user' size='large' color='grey' style={{ marginRight: '.75em' }} />
    }
  }

  const itemLabel = (itemProps) => {

    const {
      cn,
      key,
      fullKey,
      caption,
      caption_sub,
      tss,
      iconCount,
      isFirst,
      childCount,
      item
    } = itemProps

    return <Label
      className={cn}
      onClick={() => toggleKey(key, fullKey)}
      onDrop={(e) => {
        onDrop && onDrop(e, JSON.stringify(item));
        !onDrop && onDropLocal && onDropLocal(e, itemProps)
      }}>
      <div className="tv-item-caption">
        <div className={caption_sub ? "caption-subs" : null}>
          <div>
            <Icon name={expandedKeys[fullKey] ? "caret down" : "caret right"} size='large' color={'blue'} />
            {urlImage(item)}
            {!_.isObject(caption) ? caption : 'caption: ' + key}
          </div>
          {caption_sub && <div>{!_.isObject(caption_sub) ? caption_sub : 'caption_sub: ' + key}</div>}
        </div>
      </div>
      {/* This is to the right of the header */}
      <div style={{ display: 'flex', gap: '.25em', alignItems: 'center', padding: '.25em' }}>
        {tss && tss}
        {iconCount && <div>{iconCount}</div>}
        {childCount !== null && !ignoreCount && <Label size="tiny" color={'black'}>{childCount}</Label>}
        {showLastRefreshTime && <Label>{formatItem(formatTypes.fullDate, item?.metadata?.lastRefreshTime)}</Label>}
        {showHasEvent && <div><Icon name='calendar outline' size='large' color={item?._hasEvent ? 'green' : 'red'} onClick={(e) => !item?._hasEvent && handle_event(e, key, fullKey)} /></div>}
        {showHasProfile && <div><Icon name='user outline' size='large' color={item?._hasProfile ? 'green' : 'red'} onClick={(e) => !item?._hasProfile && handle_profile(e, key, fullKey)} /></div>}
        {dd(key, fullKey, isFirst, item.isPrivate)}
      </div>
    </Label>
  }

  const itemContent = (contentProps) => {

    const { item, fullKey, displayValue, isObject_value, isArray_value } = contentProps

    if (fnPopulate) {
      return fnPopulate(item)
    }

    return <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      className={'tv-md'}
    >
      {isObject_value || isArray_value ? (
        renderTree(false, item, fullKey, isArray_value ? true : false) // Recursive rendering for nested objects/arrays
      ) : (
        selectedProp === key && <Segment>
          {/* Display key-value pair */}
          <Label
            className={cn}
            size={_labelSize} >
            {'caption'}{': '}{!_.isObject(displayValue) ? displayValue : 'caption: ' + key}</Label>
        </Segment>
      )}
    </motion.div>
  }

  const allowDrop = (e) => e.preventDefault()

  const renderTree = (isFirst, obj, parentKey = "") => {

    const _obj = ignoreSort ? obj : sortComplexObject(obj)

    return _.map(_obj, (item, key) => {

      const isArray_key = _.isArray(key);
      const isObject_key = _.isObject(key) && !isArray_key;

      const { _new, _changed, _selected, _notSelected, _isPrivate } = item ?? {}

      let relatedCount = 0;

      if (showRelations && _.isObject(item)) {
        relatedCount = getArrayCount(item)
      }

      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      const isArray_value = _.isArray(item);
      const isObject_value = _.isObject(item) && !isArray_value;
      const isNumber_value = _.isNumber(item) && !isArray_value;
      const _isMatch = item && (item.home || item.pending) ? true : false

      const childCount = isArray_value ? item.length : isObject_value ? Object.keys(item).length : null;

      // Skip empty objects or arrays
      if (
        (isArray_key || isObject_key) &&
        (isArray_value || isObject_value) &&
        childCount === 0 ||
        item === null ||
        item === '' ||
        item === false
      ) return null;

      // const displayValue = typeof item === "boolean" ? item.toString() : item;
      const displayValue = isNumber_value
        ? new Intl.NumberFormat().format(item) // Format numbers for readability
        : typeof item === "boolean"
          ? item.toString()
          : item;

      let oldValue;
      let parentData;

      let cn = `tr-lbl-${(isArray_value ? 'arr' : isObject_value ? 'obj' : typeof item).slice(0, 3).toLowerCase()}${expandedKeys[fullKey] ? ' sel' : ''}`;

      if (isFirst) { cn += ' fst' }

      if (_new) { cn += ' _new' }
      if (_changed) { cn += ' _changed' }

      if (showSelected) {
        if (_selected) {
          cn += ' _selected'
        }
        if (_notSelected) {
          cn += ' _notSelected'
        }
      }

      if (itemChanges && fullKey) {
        const _fullKey = fullKey.split('.')
        if (_fullKey.length === 2) {
          if (itemChanges && itemChanges[_fullKey[0]] && itemChanges[_fullKey[0]][_fullKey[1]] && _fullKey[1] !== '_changed') {
            const itemChange = itemChanges[_fullKey[0]][_fullKey[1]]
            const { new: newValue } = itemChange ?? {}
            oldValue = newValue
            cn += ' item-changed'
          }
        }
      }

      let { caption, cni, iconGroup, caption_sub, iconCount, tss } = getKeyCaption(key, item, relatedCount);

      if (isArray_value) {
        const d = data?.[key]
        parentData = d
      }

      if (cni) { cn += ' ' + cni }

      if (_isMatch && 1 === 3) {
        const { home, away, pending, results } = item ?? {}
        if (home && away) {
          if (results?.score) {
            caption = away.name + ' ' + results?.score.away + ' @ ' + home.name + ' ' + results?.score.home
            cni = '_rez'
          } else {
            caption = away.name + ' @ ' + home.name
          }
        } else if (home) {
          caption = home.name + ' -  BYE'
        } else if (pending) {
          const { home, away } = pending ?? {}
          caption = 'Winner ' + away?.poolName + '/' + away?.matchNumber + ' @ Winner ' + home?.poolName + '/' + home?.matchNumber
        }
        return (
          <div key={fullKey} className="asdf" >
            <Label
              className={cn}
              onClick={() => toggleKey(key, fullKey)}
            >
              <div>
                <div className={caption_sub ? "caption-subs" : null}>
                  <div><Icon name={expandedKeys[fullKey] ? "caret down" : "caret right"} />{!_.isObject(caption) ? caption : 'Object: ' + key}</div>
                  {caption_sub && <div>{!_.isObject(caption_sub) ? caption_sub : 'Object: ' + key}</div>}
                </div>
              </div>
              {iconGroup && <div>{iconGroup}</div>}
            </Label>
            {expandedKeys[fullKey] && (
              <MatchView match={item} />
            )}
          </div>
        )
      } else {

        const itemProps = {
          // caption_sub,
          caption,
          childCount,
          cn,
          fullKey,
          iconCount,
          isFirst,
          key,
          tss,
          item,
        }

        const contentProps = {
          item,
          fullKey,
          displayValue,
          isObject_value,
          isArray_value
        }

        let cnw = 'tv-item-wrap'

        if (ignoreCount) {
          cnw += ' nc'
        }

        return (
          <div className={cnw} onDragOver={allowDrop}>
            <DraggableItem key={key} item={itemProps} source={key} allowDrag={allowDrag} >
              <div key={fullKey} >
                {/* Parent key as Label */}
                {(isObject_value || isArray_value) ? (
                  itemLabel(itemProps)
                ) : (
                  <ToggleLabel caption={caption} displayValue={displayValue} oldValue={oldValue} cn={cn} propKey={key} parentData={parentData} />
                )}

                {/* Child keys/values */}
                {expandedKeys[fullKey] && (
                  itemContent(contentProps)
                )}
                {/* <div style={{ backgroundColor: 'blue' }}>FOOTER</div> */}
              </div>
            </DraggableItem>
          </div>
        );
      }
    });
  };

  const _grouping = {
    alphaDisplayType: gEnums.alphaDisplayTypes.vertical,
    useVerticalHidden: true,
    verticalOpacity: gEnums.opacityTypes.light,
    restrictToExisting: true,
    showAlphaCount: true,
    origin: 'tv',
  }

  let cn = 'tree-viewer-wrapper app-dark-mode'
  if (showAlpha) { cn += ' amp' }

  const tree = () => <div className={cn} >
    {showAlpha && <AlphabetMenuWithProvider
      origin={'treeViewer'}
      handleAlphaChange={handleAlphaChange}
      dataItems={data}
      grouping={_grouping}
    // handleMouseMove={handleMouseMove}
    />}
    <div className="tree-viewer">{renderTree(true, currentList)}</div>
  </div>

  if (addJsonViewer) {
    return <div>
      <JsonViewer json={data} />
      {tree()}
    </div>
  } else {
    return tree()
  }


};

export default TreeViewer

const ToggleLabel = ({ caption, displayValue, oldValue, cn, propKey, parentData }) => {

  const [currentValue, setCurrentValue] = useState(displayValue);
  const [currentCn, setCurrentCn] = useState(cn);
  const [showProp, setShowProp] = useState()

  const handleShowProp = () => setShowProp(!showProp)

  useEffect(() => {
    // Only toggle if oldValue exists
    if (!oldValue) return;

    const interval = setInterval(() => {
      setCurrentValue(prevValue => (prevValue === displayValue ? oldValue : displayValue));
      setCurrentCn(prevValue => (prevValue === cn ? cn + ' old-val' : cn));
    }, 5000);

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, [displayValue, oldValue]);

  const renderValue = useMemo(() => {
    if (_.startsWith(currentValue, 'https://firebasestorage.googleapis.com')) {
      return <Image src={currentValue} size={'large'} />
    }
    if (_.isObject(currentValue)) {
      return `Object: ${propKey}`
    }
    return currentValue
  }, [currentValue, propKey])

  const propValue = useMemo(() => {
    if (showProp) {
      return renderValue
    }
    return (
      <Label size="tiny" color="grey">
        {renderValue}
      </Label>
    )
  }, [showProp, renderValue])

  return (
    <Label className={currentCn} onClick={() => propKey === 'description' && handleShowProp(propKey)}>
      <span className="key">{_.startCase(caption)}</span><span className="value">{propValue}</span>
    </Label>
  );
};